/**
 * Created by Carsten Bühler
 * User: CBuehler on 09.11.2015
 * Copyright: xdot GmbH 2015
 */


import { Client } from 'external/lwr-client';
import { ApiUtil } from 'plugin/liferay-widgets-react-web';

const namedListService = (m, o) => Client.invoke('/administration.namedlist/' + m, o);
const nameListServiceWithContext = (m, o, c) => Client.invokeWithContext('/administration.namedlist/' + m, o, c);

const api = {

    listViewableByGroupScope(query) {
        return nameListServiceWithContext('list-viewable-by-group-scope.1', {}, {});
    },

    get(item) {
        return nameListServiceWithContext('get.2', {
            id: item.id
        }, {});
    },

    add(item) {
        return nameListServiceWithContext('add.1', {
            'title': item.title,
            'entries': item.entries || [],
        });
    },

    update(item) {
        return nameListServiceWithContext('update.2', {
                id: item.id
            },
            {
                'title': item.title,
                'entries': item.entries,
            });
    },


    delete(query) {
        return namedListService('delete.1', {
            id: query.id
        });
    }

};

ApiUtil.namedApi('NamedListWebApi', api);

export default api;



// WEBPACK FOOTER //
// ./js/webapi/NamedListWebApi.js